import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useUIStore } from "@/stores/useUIStore";
import CoreModal from "@/components/modal/CoreModal.vue";
import LoginForm from "@/components/auth/LoginForm.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginModal',
  emits: ["login-success"],
  setup(__props, { emit: __emit }) {

const uiStore = useUIStore();
const router = useRouter();
const route = useRoute();

const isOpen = computed(() => uiStore.loginIsOpen);
const allowClose = computed(() => uiStore.allowClosePopup);

const loginForm = ref<InstanceType<typeof LoginForm> | null>(null);

const emit = __emit;

const handleClose = () => {
  loginForm.value?.reset();
  uiStore.closeLogin();
};

const handleVisibility = (value: boolean) => {
  if (!value) handleClose();
};

watch(isOpen, (value) => {
  if (!value) loginForm.value?.reset();
});

const onLoginSuccess = () => {
  const fallbackRedirect =
    typeof route.query.redirect === "string" ? route.query.redirect : null;
  const redirectTarget = uiStore.loginRedirect || fallbackRedirect || "";

  uiStore.setLoginRedirect(null);
  handleClose();

  const shouldNavigate =
    Boolean(redirectTarget) && redirectTarget !== route.fullPath;
  if (shouldNavigate) {
    router.push(redirectTarget).catch(() => null);
  }

  emit("login-success");
};

const goToRegister = () => {
  const redirectTarget = uiStore.loginRedirect || route.fullPath || "";
  uiStore.setLoginRedirect(redirectTarget);
  handleClose();
  router
    .push({ name: "Register", query: { redirect: redirectTarget } })
    .catch(() => null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreModal, {
    modelValue: isOpen.value,
    title: _ctx.$t('Login'),
    closeOnOverlay: allowClose.value,
    showCloseButton: true,
    "onUpdate:modelValue": handleVisibility
  }, {
    default: _withCtx(() => [
      _createVNode(LoginForm, {
        ref_key: "loginForm",
        ref: loginForm,
        onLoginSuccess: onLoginSuccess,
        onGoToRegister: goToRegister
      }, null, 512)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "closeOnOverlay"]))
}
}

})